import { render, staticRenderFns } from "./ShippingGoodsDetails.vue?vue&type=template&id=7ced786e"
import script from "./ShippingGoodsDetails.vue?vue&type=script&lang=js"
export * from "./ShippingGoodsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports